import { Routes, Route } from "react-router-dom";

import Login from "../pages/Login";
import Dashboard from "../pages/Dashboard";

import ProtectedRoute from "../components/ProtectedRoute";
import MainLayout from "../layouts/MainLayout";

import { clientRoutes } from "../modules/clients";
import ClientServiceAgreement from "../modules/clients/pages/ClientServiceAgreement";
import AdminRoutes from "../modules/admin/AdminRoutes";
import AssignmentRoutes from "../modules/assignments/AssignmentRoutes";

/* ================= WORK MODULE ================= */

import WorkModule from "../modules/work/WorkModule";
import MyWork from "../modules/work/pages/MyWork";
import WorkDashboard from "../modules/work/pages/WorkDashboard";
import WorkAssignments from "../modules/work/pages/WorkAssignments";
import WorkTemplateBuilder from "../modules/work/pages/WorkTemplateBuilder";
import WorkEngagementDetail from "../modules/work/pages/WorkEngagementDetail";
import WorkAreaWorkspace from "../modules/work/pages/WorkAreaWorkspace";

const AppRoutes = () => {
  return (
    <Routes>

      {/* ================= PUBLIC ROUTES ================= */}
      <Route path="/" element={<Login />} />

      {/* ================= PROTECTED LAYOUT ================= */}
      <Route
        element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }
      >

        {/* ================= DASHBOARD ================= */}
        <Route path="/dashboard" element={<Dashboard />} />

        {/* ================= WORK MODULE ================= */}
        <Route path="/tasks" element={<WorkModule />}>

          {/* Default */}
          <Route index element={<MyWork />} />

          {/* Dashboard */}
          <Route path="dashboard" element={<WorkDashboard />} />

          {/* Assignments */}
          <Route path="assignments" element={<WorkAssignments />} />

          {/* Templates */}
          <Route path="templates" element={<WorkTemplateBuilder />} />

          {/* Work Engagement */}
          <Route path="work/:workId" element={<WorkEngagementDetail />} />

          {/* ⭐ FINAL EXECUTION WORKSPACE */}
          <Route
            path="work/:workId/areas" element={<WorkAreaWorkspace />} />

        </Route>

        {/* ================= CLIENT MODULE ================= */}
        {clientRoutes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={
              <ProtectedRoute permission={route.permission}>
                {route.element}
              </ProtectedRoute>
            }
          />
        ))}

        {/* ================= ASSIGNMENT MODULE ================= */}
        <Route
          path="/assignments/*"
          element={
            <ProtectedRoute permission="ASSIGNMENT_VIEW">
              <AssignmentRoutes />
            </ProtectedRoute>
          }
        />

        {/* ================= CLIENT SERVICE AGREEMENT ================= */}
        <Route
          path="/clients/:clientId/service-agreement/:serviceId"
          element={
            <ProtectedRoute permission="CLIENT_EDIT">
              <ClientServiceAgreement />
            </ProtectedRoute>
          }
        />

        {/* ================= ADMIN ================= */}
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute permission="ADMIN_ACCESS">
              <AdminRoutes />
            </ProtectedRoute>
          }
        />

      </Route>

    </Routes>
  );
};

export default AppRoutes;